import React from 'react';
import { connect } from 'react-redux';
import { setCurrentPage, setRegisterDetails } from '../../../General/Actions';
import Network from '../../../Utils/network.js';
import Swal from 'sweetalert2';
import GeneralUtils from '../../../Utils/generalUtils.js';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import Constants from '../../../Utils/constants.json';
import { Button } from 'reactstrap';
import { FiWifi } from "react-icons/fi";
import SliderModal from '../../../Utils/sliderModal.js';
import NoDataFound from '../../../Utils/noDataFound.js';
import moment from 'moment';
import PhoneDisabled from '../../../ImageAssets/phoneCallDisabled.png';
import TVDisabled from '../../../ImageAssets/TVNewDisabled.png';
import { FaPlus, FaMinus } from 'react-icons/fa';

class PlanComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           isLoading: true,
           currentPlanAmount: "0",
           currentPlanAmount_sup: "0",
           ugradePlanAmount: "0",
           upgradePlanAmount_sup: "0",
           currentAddonDetails: [],
           oldCartDetails: [],
           oldCartDetailsDevices: [],
           isAllAddonsSliderVisble: false,
           allAddonDetails: [],
           customizeDetails: {
                devices: [],
                addons: [],
                returnDevice: [],
                showCustomizeButton: false,
            },
            currentOfferCharge: 0,
            currentMonthCharge: 0,
            currentMonthCharge_sup: 0,
            totalMonthlyCharges: 0,
            totalMonthlyCharges_sup: 0,
            activeAddonIds: "",
            offerTab: "upgradeOffer",
            upgradeOfferActiveTab: true
        }
    }

    componentDidMount() {
        this.initialisePage();
        var req = {
            "cartItem": [
                {
                    "productOffering": {
                        "id": this.props.registerDetails.offers.id,
                        "name": this.props.registerDetails.offers.name
                    },
                    "product": {
                        "productSpecification": {
                            "id": this.props.registerDetails.offers.psId,
                            "name": this.props.registerDetails.offers.psName,
                            "version": this.props.registerDetails.offers.psVesrion,
                            "poType": this.props.registerDetails.offers.poTypeName,
                            "status": this.props.registerDetails.offers.psStatus
                        }
                    }
                }
            ],
            "billingService": {
                "id": localStorage.getItem("currentServiceId")
            }
        }

        var dataToSendForPlanComaprison = {
            "finalReq": req
        }
        Network.executeAxios("planComparison", "POST", dataToSendForPlanComaprison, (planComparisonResponse) => {
                if (Object.keys(this.props.registerDetails.customize.addons).length == 0) {
                    this.props.setRegisterDetails("customize.addons", []);
                } else {
                    this.setState({ customizeDetails: this.props.registerDetails.customize })
                }

                if (planComparisonResponse.result_code === "0") {
                    this.fetchEligibilityOffers();
                    this.initialisePlanComparisonResponse(planComparisonResponse);
                } else {
                    this.setState({ isLoading: false })
                    Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "")
                    this.props.setCurrentPage("pageName", "services");
                }
                if (this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails && this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails.length == 0) {
                    this.props.setRegisterDetails("generalResponse.planComparisonData.currentAddonDetails", []);
                } else if(this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails && this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails.length > 0){
                    this.setState({ currentAddonDetails: this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails })
                }
                this.calculateTotalCharge();
                this.manageAddonEmptyBlocks();
                this.getAllAddonIds();
            })
    }

    fetchEligibilityOffers(){
        var headers = {};
        try {
            var recievedFeasibility = this.props.feasibilityResposnse.feasibilityResposne;
            if (recievedFeasibility != null && typeof (recievedFeasibility) != undefined && recievedFeasibility !== "") {
                if (recievedFeasibility.transport_type_id) {
                    headers["TransportType"] = recievedFeasibility.transport_type_id
                }
            }

        } catch (err) {

        }

        headers["CustomerType"] = this.props.userDetails.customerType;
        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
        headers["Channel"] = this.props.locales.channelIdForSCM;
        var dataToSendForEligibilityOffer = {
            "baseOfferId": this.props.registerDetails.confirmation.currentPlanId,
            "header": headers
        }

        var fetchAddoonHeader={
            "Channel": this.props.locales.channelIdForSCM
        }
        
        Network.executeAxios("fetchEligibilityOffers", "POST", dataToSendForEligibilityOffer, (response) => {
            Network.executeAxios("fetchAddons", "POST", {"pog": this.props.registerDetails.givenAddress.pog,  "header": fetchAddoonHeader} , (addonResponse) => {
                this.setState({ isLoading: false })
            var addonArray = [];
            if (response && response[0]) {
                var  finalAllAddonDetails = response;
                for (var i = 0; i < finalAllAddonDetails.length; i++) {
                    if (finalAllAddonDetails[i].success) {
                        for (var x = 0; x < finalAllAddonDetails[i].success.length; x++) {
                            addonArray.push(finalAllAddonDetails[i].success[x]);
                        }
                    }
                }
            }
            this.initializeAlladdonDetails(addonArray, addonResponse);
        })
        })
    }

    getAllAddonIds(){
        var activeAddonIds = [];
        for(var i=0;i< this.state.currentAddonDetails.length; i++){
            activeAddonIds.push(this.state.currentAddonDetails[i].planId)
        }
        this.state.activeAddonIds = activeAddonIds;
    }

    initializeAlladdonDetails(receivedResponse,stdAddonResponse) {
        var stdAddonArr = []
        for (var p = 0; p < stdAddonResponse.length; p++) {
            if (stdAddonResponse[p].success) {
                for (var q = 0; q < stdAddonResponse[p].success.length; q++) {
                    stdAddonArr.push(stdAddonResponse[p].success[q]);
                }
            }
        }
    
        var eligibilityOffers = [];
        try {
            if (Array.isArray(receivedResponse)) {
                for (var x = 0; x < receivedResponse.length; x++) {
                    eligibilityOffers.push(receivedResponse[x].eligibilityOffers)
                }
            }
        } catch (err) {
            eligibilityOffers = [];
        }

        var finaleligibilityOffers = eligibilityOffers.reduce((r, e) => (r.push(...e), r), []);
      
        var finalProductOfferingsArray = [];
        for (var i = 0; i < finaleligibilityOffers.length; i++) {
            var productOfferingsArray = [];
            try {
                if (finaleligibilityOffers[i].productOfferings) {
                    if (finaleligibilityOffers[i].maxQuantity) {
                        var productOfferingsArrayNew = finaleligibilityOffers[i].productOfferings;
                        if (productOfferingsArrayNew.length > 0) {
                            for (var j = 0; j < productOfferingsArrayNew.length; j++) {
                                productOfferingsArrayNew[j].eligibilityType = finaleligibilityOffers[i].eligibilityType.id;
                            }
                        } else {
                            console.log("productOfferingsArrayNew length 0")
                        }
                    }
                    if(finaleligibilityOffers[i].productOfferings){
                    productOfferingsArray.push(finaleligibilityOffers[i].productOfferings);
                    var productOfferingsArrayUpdated = productOfferingsArray.reduce((r, e) => (r.push(...e), r), []);
                    var maxQuantity = "100000000000000"
                    if(finaleligibilityOffers[i].maxQuantity){
                        maxQuantity = finaleligibilityOffers[i].maxQuantity
                    }

                    let temp = {
                         "groupMaxQuantity" : maxQuantity,
                         "groupMinQuantity" : finaleligibilityOffers[i].minQuantity,
                         "productOfferings" : productOfferingsArrayUpdated
                     }
                     finalProductOfferingsArray.push(temp)
                    }
                }
            }
            catch (err) { }
        }

        if(stdAddonArr.length > 0) {
            let tempObj = {
                "groupMaxQuantity" : "1000000000000000",
                "groupMinQuantity" : "0",
                "productOfferings" : stdAddonArr
            }
            finalProductOfferingsArray.push(tempObj)
        }
    

        console.log("finalProductOfferingsArray",finalProductOfferingsArray)
        this.state.allAddonDetails = finalProductOfferingsArray;
        this.setState({ dummy: "dummy" });
    }

    initialisePlanComparisonResponse(receivedResponse){
        this.state.currentOfferCharge = parseFloat(this.state.currentOfferCharge + this.props.cache.currentPlanDetails.basePlanPrice)- parseFloat(this.props.cache.currentPlanDetails.discountAmount)
        var currentAddonDetails = []
        var oldCartDetailsDevices = []
        try{
            var planComparisonResponse = receivedResponse;
            var cartItem = planComparisonResponse.oldCart.cartItem
            for(var i= 0; i < cartItem.length; i++){
                var subscriptionType = "0"
                if(cartItem[i] && cartItem[i].productOffering && cartItem[i].productOffering.subscriptionType){
                    subscriptionType = cartItem[i].productOffering.subscriptionType;
                }
                if(subscriptionType === "0"){
                    var temp = {
                        "retainable": cartItem[i].retainable,
                        "subscriptionId": cartItem[i].productOffering.subscriptionId,
                        "planId": cartItem[i].productOffering.id,
                        "planName": cartItem[i].productOffering.name,
                        "planAmount": cartItem[i].itemPrice[0].productOfferingPrice.price
                    }
                    var currentPrice = cartItem[i].itemPrice[0].productOfferingPrice.price
                    this.state.currentOfferCharge = this.state.currentOfferCharge + parseFloat(currentPrice)
                    currentAddonDetails.push(temp)
                } else if(subscriptionType === "1"){
                    var temp = {
                        "retainable": cartItem[i].retainable,
                        "subscriptionId": cartItem[i].productOffering.subscriptionId,
                        "planId": cartItem[i].productOffering.id,
                        "planName": cartItem[i].productOffering.name,
                        "planAmount": cartItem[i].itemPrice[0].productOfferingPrice.price
                    }
                    var currentPrice = cartItem[i].itemPrice[0].productOfferingPrice.price
                    this.state.currentOfferCharge = this.state.currentOfferCharge + parseFloat(currentPrice)
                    oldCartDetailsDevices.push(temp)
                }
            }
        } catch(err){
            console.log("errr>>",err)
        }

        var currentMonthCharge = "0";
        var currentMonthCharge_sup = "0"
        var currentOfferPrice = GeneralUtils.formatNumberToStandardForm(this.state.currentOfferCharge,this.props.configurationValues)
        currentOfferPrice = currentOfferPrice.split(".");
        currentMonthCharge = currentOfferPrice[0]
        if (currentOfferPrice.length > 1) {
            currentMonthCharge_sup = currentOfferPrice[1];
        } else {
            currentMonthCharge_sup = "00"
        }

        const cloneCurrentAddons = [...currentAddonDetails];
        const cloneCurrentDevices = [...oldCartDetailsDevices];
        this.props.setRegisterDetails("generalResponse.planComparisonData.oldCartDetails", cloneCurrentAddons);
        this.props.setRegisterDetails("generalResponse.planComparisonData.oldCartDetailsDevices", cloneCurrentDevices);
        this.setState({
            currentMonthCharge: currentMonthCharge,
            currentMonthCharge_sup: currentMonthCharge_sup,
            oldCartDetails: cloneCurrentAddons,
            oldCartDetailsDevices: oldCartDetailsDevices,
            currentAddonDetails: currentAddonDetails
        })

        console.log("currentAddonDetails>>>>",currentAddonDetails)
    }

    addAddonLinkClicked(){
        this.getAllAddonIds();
        this.setState({isAllAddonsSliderVisble: true})
    }

    addAddonModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ isAllAddonsSliderVisble: false })
        } else if (dataObject.type  === "submit") {
            document.body.classList.remove('modal-open');
                for(var i= 0; i < this.state.customizeDetails.addons.length; i++){
                    var currentObj = this.state.customizeDetails.addons[i]
                    var temp = {
                        "retainable": "true",
                        "subscriptionId": "",
                        "planId": currentObj.id,
                        "planName": currentObj.name,
                        "planAmount": currentObj.offerAmount
                    }
                    console.log("this.state.currentAddonDetails>>>",this.state.currentAddonDetails)
                    if(this.state.currentAddonDetails.some(x => x.planId === currentObj.id)){

                    } else {
                        this.state.currentAddonDetails.push(temp)
                    }
                }
                this.calculateTotalCharge();
                this.state.currentAddonDetails.filter(x => x.type === "emptyBlocks").forEach(x => this.state.currentAddonDetails.splice(this.state.currentAddonDetails.indexOf(x), 1));
                for(var m=0; m< this.state.customizeDetails.addons.length; m++){
                    this.manageAddonEmptyBlocks();
                }
            this.setState({ isAllAddonsSliderVisble: false })
        }
    }

    manageAddonEmptyBlocks(){
        if(this.state.oldCartDetails.length < this.state.currentAddonDetails.length){
            this.state.oldCartDetails.push({
                "type": "emptyBlocks",
                "retainable": "",
                "subscriptionId": "",
                "planId": "",
                "planName": "",
                "planAmount": 0
            })
        } else if(this.state.currentAddonDetails.length < this.state.oldCartDetails.length){
            this.state.currentAddonDetails.push({
                "type": "emptyBlocks",
                "retainable": "",
                "subscriptionId": "",
                "planId": "",
                "planName": "",
                "planAmount": 0
            })
        } else {
            try{
                var currentAddonDetailsLastObj = [ ...this.state.currentAddonDetails ].pop();
                var oldCartDetailsLastObj = [ ...this.state.oldCartDetails ].pop();
                if(currentAddonDetailsLastObj.type === "emptyBlocks" && oldCartDetailsLastObj.type === "emptyBlocks"){
                    this.state.currentAddonDetails.splice(-1);
                    this.state.oldCartDetails.splice(-1);
                }
            } catch(err){
                
            }
        }
        this.setState({"dummy":"dummy"})
    }

    removeAddonLinkClicked(receivedData){
        Swal.fire({
            title: this.props.locales.removeAddonConfirmMsgInPlanComparison,
            text: "",
            type: '',
            showCancelButton: true,
            confirmButtonText: this.props.locales.okButtonTextInSwal,
            cancelButtonText: this.props.locales.cancelButtonTextInSwal,
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                this.state.currentAddonDetails.filter(x => x.planId === receivedData).forEach(x => this.state.currentAddonDetails.splice(this.state.currentAddonDetails.indexOf(x), 1));
                this.manageAddonEmptyBlocks()
                this.removeAddonClickedForAddon(receivedData)
             }
        });
    }

    selectAddonClickedForAddon(receivedData, minCount, allAddonDetail) {
        receivedData = JSON.parse(decodeURIComponent(receivedData))
        var allAddonids = [];
        var groupMaxQuantity = allAddonDetail.groupMaxQuantity
        for (var j = 0; j < allAddonDetail.productOfferings.length; j++) {
            var currentProductOffering = allAddonDetail.productOfferings[j];
            allAddonids.push(currentProductOffering.id);
        }
        var maxcountAlowed = 0
        for (var k = 0; k < this.state.customizeDetails.addons.length; k++) {
            if (allAddonids.includes(this.state.customizeDetails.addons[k].id)) {
                maxcountAlowed = parseInt(maxcountAlowed) + (parseInt(this.state.customizeDetails.addons[k].count))
            }
        }
        if (parseInt(groupMaxQuantity) > parseInt(maxcountAlowed)) {
            if (parseInt(minCount) > 0) {
                receivedData["count"] = minCount;
            } else {
                receivedData["count"] = 1;
            }
            receivedData["showCustomizeButton"] = true;
            this.state.customizeDetails.addons.push(receivedData);
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.setState({ showCustomizeButton: true });
        } else {
            Swal.fire(this.props.locales.canNotChooseThisQuantityInAddonSelection);
        }

    }

    countPlusButtonClickedForAddon(receivedData, maxCount, allAddonDetail,event) {
        event.stopPropagation();
        var allAddonids = [];
        var groupMaxQuantity = allAddonDetail.groupMaxQuantity
        for (var j = 0; j < allAddonDetail.productOfferings.length; j++) {
            var currentProductOffering = allAddonDetail.productOfferings[j];
            allAddonids.push(currentProductOffering.id);
        }
        var maxcountAlowed = 0
        for (var k = 0; k < this.state.customizeDetails.addons.length; k++) {
            if (allAddonids.includes(this.state.customizeDetails.addons[k].id)) {
                maxcountAlowed = parseInt(maxcountAlowed) + (parseInt(this.state.customizeDetails.addons[k].count))
            }
        }

        if (parseInt(groupMaxQuantity) > parseInt(maxcountAlowed)) {
            var temp = [];
            Object.assign(temp, this.state.customizeDetails.addons);
            for (var i = 0; i < temp.length; i++) {
                if (temp[i].count < maxCount && temp[i].id == receivedData) {
                    temp[i].count = parseInt(temp[i].count) + 1
                }
            }
            this.state.customizeDetails.addons = temp;
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
        } else {
           
        }

        this.setState({ "dummy": "dummy" })
    }

    countMinusButtonClickedForAddon(receivedData, allAddonDetail,event) {
        event.stopPropagation();
        var temp = [];
        Object.assign(temp, this.state.customizeDetails.addons);
        for (var i = 0; i < temp.length; i++) {
            if (temp[i].count > 1) {
                if (temp[i].id == receivedData) {
                    temp[i].count = temp[i].count - 1
                }
            }
        }
        this.state.customizeDetails.addons = temp;
        this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
        this.setState({ "dummy": "dummy" })
    }

    removeAddonClickedForAddon(receivedData,allAddonDetail) {
        this.state.customizeDetails.addons.filter(x => x.id === receivedData).forEach(x => this.state.customizeDetails.addons.splice(this.state.customizeDetails.addons.indexOf(x), 1));
        this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
        this.calculateTotalCharge();
        this.manageAddonEmptyBlocks();
    }

    populateCurrentAddons(){
        const allPackages = this.state.oldCartDetails.map((item, key) => {
            return(
                <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" key={key} style={{borderBottom: '1px solid #D3D3D3',height: 72}}>
                    <div>{item.planName}</div>
                    {parseFloat(item.planAmount) > 0 ?
                    <div>
                        ${GeneralUtils.formatNumberToStandardForm(item.planAmount,this.props.configurationValues)}
                    </div>
                    : null }
                </div>
            )
        })
        if (this.state.oldCartDetails.length > 0) {
            return (allPackages)
        } else {
            return(
                <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" style={{borderBottom: '1px solid #D3D3D3',height: 72}}>
                   No Addons Available
                </div>
            )
        }
    }

    populateCurrentDevices(){
        const allPackages = this.state.oldCartDetailsDevices.map((item, key) => {
            return(
                <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" key={key} style={{borderBottom: '1px solid #D3D3D3',height: 72}}>
                    <div>{item.planName}</div>
                    {parseFloat(item.planAmount) > 0 ?
                    <div>
                        ${GeneralUtils.formatNumberToStandardForm(item.planAmount,this.props.configurationValues)}
                    </div>
                    : null }
                </div>
            )
        })
        if (this.state.oldCartDetailsDevices.length > 0) {
            return (allPackages)
        } else {
            return( <div className="col-md-12 px-4 align-items-center d-flex justify-content-between" style={{borderBottom: '1px solid #D3D3D3', height: 72}}>
                        No Devices Available
                    </div>
                )
        }
    }

    populateUpgradeAddons(){
        const allPackages = this.state.currentAddonDetails.map((item, key) => {
            return(
                <div className="col-md-12 px-4 align-items-center d-flex justify-content-between" key={key} style={{borderBottom: '1px solid #D3D3D3', height: 72}}>
                    <div className="">
                        <div>{item.planName}</div>
                        <div>
                            {item.retainable === "false" ?
                                <span style={{fontSize:12, color: '#E31937', fontWeight: 500}}>Not Applicable</span>
                            : null }
                            {item.retainable === "true" ?
                                <span style={{fontSize:12, color: '#407CCA', fontWeight: 500,cursor: 'pointer'}} onClick={() => this.removeAddonLinkClicked(item.planId)}>Remove</span>
                             : null }
                            </div>
                    </div>
                    { parseFloat(item.planAmount) > 0 ?
                    <div>${GeneralUtils.formatNumberToStandardForm(item.planAmount,this.props.configurationValues)}</div>
                    : null }
                </div>
            )
        })
        if (this.state.currentAddonDetails.length > 0) {
            return (allPackages)
        } else {
            return(
                <div className="col-md-12 px-4 align-items-center d-flex justify-content-between" style={{borderBottom: '1px solid #D3D3D3', height: 72}}>
                    No Addons Available
                </div>
            )
        }
    }

    populateAllAddonDetails(){
        var isAddonPresent = false;
        const allAddons = this.state.allAddonDetails.map((itemArray, key) => {
            var currentItemArray = itemArray.productOfferings;
            return currentItemArray.map((item, key) => {
            try{
                var productPrice = {}
                if (item.productOfferingPrice[0]) {
                    for (var i = 0; i < item.productOfferingPrice.length; i++) {
                        if(item.productOfferingPrice[i] && item.productOfferingPrice[i].priceCategory){
                            if (item.productOfferingPrice[i].priceCategory.id === "0") {
                                productPrice = item.productOfferingPrice[i];
                            }
                        }
                       
                    }
                }
            var packageAmount = ""
            var packageAmount_sup = ""
            try{
                if(productPrice.price){
                    var price = productPrice.price;
                }
                price = price.split(".");
                packageAmount = price[0]
                if(price.length > 1){
                    packageAmount_sup = price[1];
                } else{
                    packageAmount_sup = "00"
                }
            } catch(err){
                packageAmount = 0
                packageAmount_sup = "00"
            }

            var contextValue = ""
            try {
                if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                    for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                        if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                            contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                        }
                    }

                }
            } catch (err) {
                contextValue = ""
            }

            var productSubtype = {}
            try {
                if (item.productSpecifications[0]) {
                    productSubtype = item.productSpecifications[0].subType;
                }
            } catch (err) {
                productSubtype = {}
            }
            var poType = {}
            try {
                if (item.productSpecifications[0]) {
                    poType = item.productSpecifications[0].type;
                }
            } catch (err) {
                poType = {}
            }

            var productOfferGroup = {}
            try {
                if (item.productOfferGroup) {
                    productOfferGroup = item.productOfferGroup;
                }
            } catch (err) {
                productOfferGroup = {}
            }

            var skipSom = "false";
            var cfss = []
            try {
               for(var m = 0; m < item.productSpecifications.length; m++){
                   var currentPS = item.productSpecifications[m];
                   if(currentPS.releationships && currentPS.releationships[0]){
                        skipSom = currentPS.releationships[0].skipSOM
                    }
                   for(var n = 0; n< currentPS.cfss.length; n++){
                    var currentObjCfss = currentPS.cfss[n];
                    currentObjCfss["skip_som"] = skipSom
                    cfss.push(currentObjCfss)
                    delete currentObjCfss.validFor
                   }
               }
            } catch (err) {
                cfss = []
            }

            var cfssArray = []
            for (var x = 0; x < cfss.length; x++) {
                let temp = {
                    "id": cfss[x].id,
                    "name": cfss[x].name,
                    "href": cfss[x].href,
                    "service_type": cfss[x].serviceType,
                    "service_class": cfss[x].serviceClass,
                    "transport_type": cfss[x].transportType,
                    "service_category": cfss[x].serviceCategory,
                    "characteristics": cfss[x].characteristics,
                    "skip_som": cfss[x].skip_som
                }
                cfssArray.push(temp);
            }
            var isRedeemable=false;
            for(var y=0;y<cfssArray.length;y++){
                if(cfssArray[y].characteristics){
                    var characteristics=cfssArray[y].characteristics;
                    for(var k=0;k<characteristics.length;k++){
                        if(characteristics[k].name && characteristics[k].value){
                            if(characteristics[k].name=="isRedeemable" && characteristics[k].value=="true"){
                                isRedeemable=true;
                            }
                        }
                    }
                }
            }

            var MinLoyaltyPoints="0";
            for(var y=0;y<cfssArray.length;y++){
                if(cfssArray[y].characteristics){
                    var characteristics=cfssArray[y].characteristics;
                    for(var k=0;k<characteristics.length;k++){
                        if(characteristics[k].name && characteristics[k].value){
                            if(characteristics[k].name=="MinLoyaltyPoints"){
                                MinLoyaltyPoints=characteristics[k].value
                            }
                        }
                    }
                }
            }

            var connectionType= "POSTPAID";
            for(var p=0;p<cfssArray.length;p++){
                if(cfssArray[p].characteristics){
                    var characteristics=cfssArray[p].characteristics;
                    for(var q=0;q<characteristics.length;q++){
                        if(characteristics[q].name && characteristics[q].value){
                            if(characteristics[q].name=="CONNECTION_TYPE"){
                                connectionType = characteristics[q].value.toUpperCase()
                            }
                        }
                    }
                }
            }

            var subscriptionCharges = []
            var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
            var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
            if(item.ratingParameters && item.ratingParameters[0]){
                var ratingParam = item.ratingParameters[0]
                if(item.productOfferingPrice[0].priceMode.id == "1"){
                    if(ratingParam && ratingParam.subscriptionPeriod){
                        var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                        if(ratingParam.subscriptionPeriodType.id == "0"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                        } else if(ratingParam.subscriptionPeriodType.id === "1"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                        } else if(ratingParam.subscriptionPeriodType.id === "2"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'Monthly');
                        } else if(ratingParam.subscriptionPeriodType.id === "3"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                        } else if(ratingParam.subscriptionPeriodType.id === "4"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                        }
                    }
                }
            }

            expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss") 

            var subscriptionCharges = []
            for (var k = 0; k < item.productOfferingPrice.length; k++) {
                var prorata_flags = ""
                try {
                    var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                    var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                    var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                    var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                    prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                } catch (err) {
                    prorata_flags = ""
                }
                var factor = ""
                if (item.productOfferingPrice[k].factor) {
                    factor = item.productOfferingPrice[k].factor
                }
                var frequency = ""
                if (item.productOfferingPrice[k].frequency) {
                    frequency = item.productOfferingPrice[k].frequency.id
                }

                let tempCharges = {}
                try {
                    tempCharges = {
                        "upc_charge_id": item.productOfferingPrice[k].id,
                        "charge_type": item.productOfferingPrice[k].priceMode.id,
                        "charge_name": item.productOfferingPrice[k].name,
                        "charge_desc": item.productOfferingPrice[k].description,
                        "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                        "end_date": expiry_date,
                        "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                        "charge_validity": "",
                        "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                        "charge_id": item.id,
                        "discount_type": item.productOfferingPrice[k].priceType.name,
                        "epc_enabled": "1",
                        "quantity_based": "",
                        "charge_classification": "",
                        "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                        "charge_frequency": frequency,
                        "charge_factor": factor,
                        "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                        "prorata_flags": prorata_flags,
                        "charge_code": item.productOfferingPrice[k].priceCode.id
                    }
                    if(connectionType === "POSTPAID"){
                        tempCharges["charge_amount"] = item.productOfferingPrice[k].price
                        tempCharges["total_charge"] = item.productOfferingPrice[k].price
                    } else {
                        tempCharges["charge_amount"] = "0"
                        tempCharges["total_charge"] = "0"
                    }
                } catch (err) {
                    tempCharges = {}
                }
                subscriptionCharges.push(tempCharges)
            }

            var pogIdFromResponse = item.productOfferGroup.id;
            var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id
           
            var currentAddonDataTemp = {};
            currentAddonDataTemp["id"] = item["id"];
            currentAddonDataTemp["name"] = item["marketingDescription"];
            currentAddonDataTemp["description"] = item["description"] || "NA";
            currentAddonDataTemp["offerAmount"] = productPrice.price || 0;
            currentAddonDataTemp["productSubtype"] = productSubtype.id || 0;
            currentAddonDataTemp["effective_date"] = effective_date;
            currentAddonDataTemp["expiry_date"] = expiry_date;
            currentAddonDataTemp["productId"] = productOfferGroup.id;
            currentAddonDataTemp["productName"] = productOfferGroup.name;
            currentAddonDataTemp["poType"] = poType.id;
            currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
            currentAddonDataTemp["contextValue"] = contextValue;
            currentAddonDataTemp["po_sub_type"] = "0";
            currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
            currentAddonDataTemp["eligibilityType"] = item.eligibilityType || 0;
            currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
            currentAddonDataTemp["isRedeemable"] = isRedeemable;
            currentAddonDataTemp["MinLoyaltyPoints"] = MinLoyaltyPoints;
            currentAddonDataTemp["connectionType"] = connectionType;
            if (cfssArray.length > 0) {
                currentAddonDataTemp["cfss"] = cfssArray;
            }
        }
            catch(err){
                currentAddonDataTemp = {}
            }
            var currentAddonData = encodeURIComponent(JSON.stringify(currentAddonDataTemp));
          
            var isSelected = false;
            for (var l = 0; l < this.state.customizeDetails.addons.length; l++) {
                if (item["id"] === this.state.customizeDetails.addons[l].id) {
                    isSelected = true
                }
            }
          
            var isFnfAddonPresent = "false"
            if(item.ratingParameters && item.ratingParameters[0]){
                isFnfAddonPresent = item.ratingParameters[0].friendsAndFamily;
            }

            var isSelected = false;
            for (var i = 0; i < this.state.customizeDetails.addons.length; i++) {
                if (item["id"] == this.state.customizeDetails.addons[i].id) {
                    isSelected = true
                    var count = this.state.customizeDetails.addons[i].count;
                    var id = this.state.customizeDetails.addons[i].id;
                }
            }

            var maxQuantity = "1"
            if(item && item.maxQuantity){
                maxQuantity = item.maxQuantity
            }

            var minQuantity = "0"
            if(item && item.minQuantity){
                minQuantity = item.minQuantity
            }

            if(this.state.activeAddonIds.includes(item.id)){

            }
            else if(isFnfAddonPresent !== "true"){
                isAddonPresent = true;
                return (
                    <div className="col-md-12 upgradePlanAddAddon" key={key}>
                    <div className={isSelected ? "allAddonDetailForAddon align-items-center mb-3 row m-0 pb-2 px-2 mx-auto" : "allAddonDetailForAddonInactive align-items-center mb-3 row m-0 pb-2 px-2 mx-auto" }
                        onClick={() => isSelected ? this.removeAddonClickedForAddon(item.id, itemArray) : this.selectAddonClickedForAddon(currentAddonData, minQuantity, itemArray) } >
                        <div className="col-md-12" style={{ height: 30 }}>{isSelected ?
                            <div className="selectedBadge">
                                Selected
                            </div>
                            :
                            <div>
                            </div>
                        }
                        </div>
                       
                        <div className="col-12 row p-0 px-2 m-0 pt-2 justify-content-between">
                            <div className="nameContainer col-9 p-0">{item.marketingDescription}</div>
                            <div className="col-3 row m-0 p-0">
                            {maxQuantity === "1" || maxQuantity === minQuantity
                                ?
                                null 
                            :
                            <div className="col-md-12 row p-0 m-0">
                            {isSelected
                                ?
                                    <div className="col-md-12 row p-0 m-0 pb-2">
                                        <div className="input-group" style={{ width: '80%', height: 25, marginLeft: 'auto' }}>
                                            <div className="input-group-prepend" style={{ marginRight: 0 }}>
                                                <span className="input-group-text" style={{ marginTop: 9, height: 18, padding: '0px 5px', cursor: 'pointer', borderRadius: '50%', border: '1px solid #404142' }} onClick={(event) => { this.countMinusButtonClickedForAddon(item.id, itemArray,event) }}>
                                                    <FaMinus style={{ fontSize: 8, height: 12 }} />
                                                </span>
                                            </div>
                                            <input type="text" className="form-control" style={{ fontWeight: 700, border: 0, fontSize: 13, padding: 0, textAlign: 'center' }} value={count} />
                                            <div className="input-group-append" style={{ marginLeft: 0 }}>
                                                <span className="input-group-text" style={{ marginTop: 9, height: 18, padding: '0px 5px', cursor: 'pointer', borderRadius: '50%', border: '1px solid #404142' }} onClick={(event) => { this.countPlusButtonClickedForAddon(id, maxQuantity, itemArray,event) }}>
                                                    <FaPlus style={{ fontSize: 8, height: 12 }} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                :
                                null
                            }
                        </div>
                        }
                            <div className="col-md-12 p-0 text-right d-flex justify-content-end" style={{ color: '#231F20', fontWeight: 500 }}>
                                    <span style={{fontSize:12}}>$</span><span style={{lineHeight:'22px', fontSize: 18}}>{packageAmount}</span><span style={{fontSize:12}}>{packageAmount_sup}/mo.</span>
                                   
                            </div>
                        </div>
                </div>
                        <div className="col-md-12 row p-0 px-2 m-0 pb-2">
                            <div className="nameContainerDesc">{item.description}</div>
                        </div>
                    </div>
                </div>
                );
            }
        })
    })
        if(isAddonPresent) {
            return (allAddons)
        } else {
            return(
                <div className="col-md-12"><NoDataFound content="No Addons Found" /></div>
            )
        }
    }

    initialisePage(){
        var packageAmount = "0";
        var packageAmount_sup = "0";
        var upgradePlanAmount = "0";
        var upgradePlanAmount_sup = "0";
      
        var Price = GeneralUtils.formatNumberToStandardForm(this.props.cache.currentPlanDetails.basePlanPrice,this.props.configurationValues)
        Price = Price.split(".");
        packageAmount = Price[0]
        if (Price.length > 1) {
            packageAmount_sup = Price[1];
        } else {
            packageAmount_sup = "00"
        }

        var upgradePrice = GeneralUtils.formatNumberToStandardForm(this.props.registerDetails.offers.offerAmount,this.props.configurationValues)
        upgradePrice = upgradePrice.split(".");
        upgradePlanAmount = upgradePrice[0]
        if (upgradePrice.length > 1) {
            upgradePlanAmount_sup = upgradePrice[1];
        } else {
            upgradePlanAmount_sup = "00"
        }

        this.setState({
            currentPlanAmount: packageAmount,
            currentPlanAmount_sup: packageAmount_sup,
            upgradePlanAmount: upgradePlanAmount,
            upgradePlanAmount_sup: upgradePlanAmount_sup
        })
    }

    calculateTotalCharge() {
        let sum = 0;
        for (var i = 0; i < this.state.currentAddonDetails.length; i++) {
            if(this.state.currentAddonDetails[i].retainable !== "false"){
                sum = sum + parseFloat(this.state.currentAddonDetails[i].planAmount)
            }
        }

        for(var k=0; k< this.state.oldCartDetailsDevices.length; k++){
            sum = sum + parseFloat(this.state.oldCartDetailsDevices[k].planAmount)
        }

        sum = sum + (parseFloat(this.props.registerDetails.offers.offerAmount) - parseFloat(this.props.registerDetails.offers.discount))

        var currentMonthCharge = "0";
        var currentMonthCharge_sup = "0"
        var currentOfferPrice = GeneralUtils.formatNumberToStandardForm(sum,this.props.configurationValues)
        currentOfferPrice = currentOfferPrice.split(".");
        currentMonthCharge = currentOfferPrice[0]
        if (currentOfferPrice.length > 1) {
            currentMonthCharge_sup = currentOfferPrice[1];
        } else {
            currentMonthCharge_sup = "00"
        }

        this.setState({
            totalMonthlyCharges : currentMonthCharge,
            totalMonthlyCharges_sup: currentMonthCharge_sup
        })

        this.setState({ dummy: "dummy" });
    }

    comparisonButtonClicked(type){
        if(type === "back"){
            this.props.setRegisterDetails("generalResponse.planComparisonData.currentAddonDetails", []);
            this.props.setCurrentPage("pageName", "services");
        } else if(type === "next"){
            console.log("this.state.customizeDetails.addons",this.state.customizeDetails.addons)
            // for(var k=0;  k< this.state.customizeDetails.addons.length; k++){
            //     for(var m=0; m < this.state.oldCartDetails.length; m++){
            //         var currentAddon = this.state.customizeDetails.addons[k]
            //         if(currentAddon.id === this.state.oldCartDetails[m].planId){
            //             this.state.customizeDetails.addons.splice(k,1);
            //         }
            //     }
            // }
           
            this.props.setRegisterDetails("generalResponse.planComparisonData.currentAddonDetails", this.state.currentAddonDetails);
            this.props.setCurrentPage("pageName", "confirmation");
        }
    }

    planComparisonTablinkClicked(type) {
        if (type == "upgradeOffer") {
            this.setState({
                offerTab: type,
                currentOfferActiveTab: false,
                upgradeOfferActiveTab: true
            })
        } else if (type == "currentOffer") {
            this.setState({
                offerTab: type,
                currentOfferActiveTab: true,
                upgradeOfferActiveTab: false
            })
        }
    }

    populateCurrentOfferDetails(){
        return(                                    
        <div className="col-md-6">
        <div className="col-md-12 row p-0 mx-auto d-none d-md-block">
            <div className="col-md-12 pb-1 p-0" style={{color:'#58595B',fontSize:18,fontWeight:500,borderBottom:'1px solid #d6d6d6'}}>Current Offer</div>
        </div>
        <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4">Offer</div>
        <div className="col-md-12 row mx-auto py-2 currentOfferBackground" style={{minHeight: 132}}>
            <div className="d-flex col-12 p-0 row m-0">
                <div className="d-flex col-2 p-0 pt-3 pb-2">
                    <div className="">
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><FiWifi style={{ fontSize: 20, color: '#b3b3b3', opacity: '0.5' }} /></span>
                        : null
                    }
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><img src={TVDisabled} alt="" /></span>
                        : null
                    }
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><img src={PhoneDisabled} alt="" /></span>
                        : null
                    }
                    </div>
                </div>
                <div className="d-flex col-10 p-0 py-2 mt-1">
                    <div className="pr-3 text-right col-md-12 p-0">
                        {parseFloat(this.state.currentPlanAmount) > 0 ?
                        <div style={{ color: '33495F', fontSize: 22 }}>
                            {Constants.dollarSign}{this.state.currentPlanAmount}<sup>.{this.state.currentPlanAmount_sup}{this.props.locales.perMonthTextForAmount}</sup>
                        </div>
                        : null }
                    </div>
                </div>
            </div>
            <div className="col-md-12 pb-2 nameContainer" title={this.props.cache.currentPlanDetails.activePlanName}>
                {this.props.cache.currentPlanDetails.activePlanName}
            </div>
            <div className="col-md-12 nameContainerDescComparison pb-2" title={this.props.cache.currentPlanDetails.activePlanDesc}>
                {this.props.cache.currentPlanDetails.activePlanDesc}
            </div>
        </div>
       
        {this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase()
        ?
        null :
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4">Add-on(s)</div>
            <div className="col-md-12 p-0 currentOfferBackground">
                {this.populateCurrentAddons()}
            </div>
        </div>
        }

        {this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase()
        ?
        null :
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4">Device(s)</div>
            <div className="col-md-12 p-0 currentOfferBackground">
                {this.populateCurrentDevices()}
            </div>
        </div>
        }

        {/* discount */}

        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4">Discounts</div>
            <div className="col-md-12 p-0 currentOfferBackground">
                {parseFloat(this.props.cache.currentPlanDetails.discountAmount) > 0 ?
                    <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #D3D3D3', height: 72 }}>
                        <div>{this.props.cache.currentPlanDetails.discountName}</div>
                        <div>
                            ${GeneralUtils.formatNumberToStandardForm(this.props.cache.currentPlanDetails.discountAmount,this.props.configurationValues)}
                        </div>
                    </div>
                    : <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #D3D3D3', height: 72 }}>
                        NA
                    </div>
                }
            </div>
        </div>
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pt-4 pb-3 pl-1" style={{color:'#33495F',fontSize:20,fontWeight:500,height:45}}></div>
            <div className="currentOfferBackground col-md-12 p-0" style={{height:60, display: 'flex', alignItems: 'center'}}>
                <div className="col-md-12 px-4 align-items-center d-flex justify-content-between">
                    <div style={{color:'#33495F',fontSize:18,fontWeight:500}}>Total</div>
                    <div style={{color:'#33495F',fontSize:20,fontWeight:300}}>${this.state.currentMonthCharge}<sup>.{this.state.currentMonthCharge_sup}/mo</sup></div>
                </div>
            </div>
        </div>

    </div>)
    }

    populateUpgradeOfferDetails(){
        return(                                    
        <div className="col-md-6">
        <div className="col-md-12 row p-0 mx-auto d-none d-md-block">
            <div className="col-md-12 pb-1 p-0" style={{color:'#58595B',fontSize:18,fontWeight:500,borderBottom:'1px solid #d6d6d6'}}>Updated Offer</div>
        </div>
        <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4"><span className="d-block d-md-none">Offer</span></div>
        <div className="col-md-12 row mx-auto py-2 upgradeOfferBackground" style={{minHeight: 132}}>
            <div className="d-flex col-12 p-0 row m-0">
                <div className="d-flex col-2 p-0 pt-3 pb-2">
                    <div className="">
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><FiWifi style={{ fontSize: 20, color: '#b3b3b3', opacity: '0.5' }} /></span>
                        : null
                    }
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><img src={TVDisabled} alt="" /></span>
                        : null
                    }
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase() 
                        ?
                        <span className="offerHeadInnerDiv ml-2"><img src={PhoneDisabled} alt="" /></span>
                        : null
                    }
                    </div>
                </div>
                <div className="d-flex col-10 p-0 py-2 mt-1">
                    <div className="pr-3 text-right col-md-12 p-0">
                        <div style={{ color: '33495F', fontSize: 22 }}>
                            {Constants.dollarSign}{this.state.upgradePlanAmount}<sup>.{this.state.upgradePlanAmount_sup}{this.props.locales.perMonthTextForAmount}</sup>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 pb-2 nameContainer" title={this.props.registerDetails.offers.name}>
                {this.props.registerDetails.offers.name}
            </div>
            <div className="col-md-12 nameContainerDescComparison pb-2" title={this.props.registerDetails.offers.description}>
                {this.props.registerDetails.offers.description}
            </div>
        </div>

        {this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase()
        ?
        null :
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4 row m-0 p-0 align-items-center justify-content-md-end justify-content-between">
                <span className="d-block d-md-none">Addon(s)</span>
                <span style={{ color: '#407CCA', fontSize: 12, fontWeight: 500, cursor: 'pointer', textAlign: 'right' }} onClick={() => this.addAddonLinkClicked()}>Add Add-on(s)</span>
            </div>
            <div className="col-md-12 p-0 upgradeOfferBackground">
                {this.populateUpgradeAddons()}
            </div>
        </div>
        }

    {this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase()
        ?
        null :
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4"><span className="d-block d-md-none">Device(s)</span></div>
            <div className="col-md-12 p-0 upgradeOfferBackground">
                {this.populateCurrentDevices()}
            </div>
        </div>
        }

        {/* discount */}
    
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pl-1 planComparisonSecHeading pt-4"><span className="d-block d-md-none">Discounts</span></div>
            <div className="col-md-12 p-0 upgradeOfferBackground">
                {parseFloat(this.props.registerDetails.offers.discount) > 0 ?
                    <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #D3D3D3', height: 72 }}>
                        <div>{this.props.registerDetails.offers.discountName}</div>
                            <div>
                                ${GeneralUtils.formatNumberToStandardForm(this.props.registerDetails.offers.discount,this.props.configurationValues)}
                            </div>
                    </div>
                 : <div className="col-md-12 px-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #D3D3D3', height: 72 }}>
                     NA
                    </div>
                 }
            </div>
        </div>
        <div className="col-md-12 row m-0 p-0">
            <div className="col-md-12 px-0 pt-4 pb-3 pr-1 text-right" style={{color:'#E21736',fontSize:14,height:45}}></div>
            <div className="upgradeOfferBackground col-md-12 p-0" style={{height:60, display: 'flex', alignItems: 'center'}}>
                <div className="col-md-12 px-4 align-items-center d-flex justify-content-between">
                    <div style={{color:'#000000',fontSize:18,fontWeight:500}}>Total</div>
                    <div style={{color:'#000000',fontSize:28,fontWeight:300}}>${this.state.totalMonthlyCharges}<sup>.{this.state.totalMonthlyCharges_sup}/mo</sup></div>
                </div>
            </div>
        </div>
    </div>)
    }

    render() {
        return(
            <div id="customizePartTopDivContainer">
                    {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        )
    }

    componentContent() {
        return (
            <div id="changePlanCustomizeMainContainer" className="px-sm-5 px-0 mt-4">
                <div className="col-md-12 row changePlanCustomizePart mt-2 px-4">
                    <div className="col-md-12 pb-4 pl-2">
                        <div className="pt-2 mt-sm-0 mt-4 pb-3" style={{fontSize: 18}}>Compare Offer</div>
                        <div className="col-md-12 pt-3 planComparisonContainer">
                            <div className="col-md-12 row pb-5 m-0 p-0">
                                <div className="col-md-12 row m-0 p-0">
                                <div className="d-block d-md-none col-12 row m-0 p-0 mt-4">
                                    <div className="col-12 row m-0 p-0">
                                        <div className={this.state.upgradeOfferActiveTab == true ? "tabHeader activeTabHeader" : "tabHeader"} onClick={() => { this.planComparisonTablinkClicked('upgradeOffer') }} style={{ color: '#58595B' }}> Updated Offer</div>
                                        <div className={this.state.currentOfferActiveTab == true ? "tabHeader activeTabHeader" : "tabHeader"} onClick={() => { this.planComparisonTablinkClicked('currentOffer') }} style={{ color: '#58595B' }} >Current Offer</div>
                                    </div>
                                    {this.state.offerTab === "upgradeOffer" ?
                                        this.populateUpgradeOfferDetails()
                                        :
                                        this.populateCurrentOfferDetails()
                                    }
                                </div>
                                <div className="planComparisonDetailsDiv col-md-12 row p-0 m-0">
                                    {this.populateCurrentOfferDetails()}
                                    {this.populateUpgradeOfferDetails()}
                                </div>
                            </div>      
                           </div>
                           </div>
                           <div className="col-md-12 changePlanBottomDiv d-flex justify-content-end align-items-center" style={{backgroundColor: '#FFFFFF'}}>
                                <Button className="changePlanBackButton mb-4" onClick={() => { this.comparisonButtonClicked("back") }}>
                                    Back
                                </Button>
                                <Button className="changePlanNextButton mb-4" onClick={() => { this.comparisonButtonClicked("next") }}>
                                    Next
                                </Button>
                            </div>
                            <div className="col-md-12 planComaprisonBottomDivMob justify-content-between align-items-center row m-0 mx-auto d-none">
                                <Button className="changePlanBackButton mb-4" onClick={() => { this.comparisonButtonClicked("back") }}>
                                    Back
                                </Button>
                                <Button className="changePlanNextButton mb-4" onClick={() => { this.comparisonButtonClicked("next") }}>
                                    Next
                                </Button>
                            </div>
                        </div>
               </div>

                <SliderModal
                    isVisible={this.state.isAllAddonsSliderVisble}
                    uniqueModalReferenceId="addAddon"
                    mainHeading="Choose Addon"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Submit"
                    callback={this.addAddonModalHandler}
                >
                        <div className="col-md-12 px-2" style={{height:'100%'}}>
                            {this.populateAllAddonDetails()}
                        </div>
                 
                </SliderModal>

            </div>
        ); 
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        currentPage: state.currentPage,
        cache: state.cache,
        feasibilityResposnse: state.feasibilityResposnse,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        }, setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        }
    }
}

const PlanComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlanComponent)


export default PlanComponentContainer;

